// 问 AI 的常见问题库（按项目管理的几个维度分组）。每个问题有固定的 key：
// 前端点哪个就把 key 发给服务端，服务端按 key 准备对应的数据范围和回答格式（services/ask.ts 的 RULES）。

export type AskCategory = '进度与风险' | '承诺与交付' | '依赖与协作' | '资源与负荷' | '汇报与沟通' | '我的工作';

export interface AskPreset {
  key: AskPresetKey;
  category: AskCategory;
  /** 显示在按钮上、也作为提问内容 */
  question: string;
  /** 只对主管和管理员显示 */
  managerOnly?: boolean;
  /** 要先选一个项目 */
  needsProject?: boolean;
}

export const ASK_PRESET_KEYS = [
  'blockers',
  'delay_risk',
  'stalled',
  'risk_register',
  'commitments',
  'due_soon',
  'milestones',
  'waiting',
  'cross_team',
  'workload',
  'reporting_gaps',
  'weekly_summary',
  'standup',
  'project_brief',
  'my_progress',
  'my_priorities',
] as const;
export type AskPresetKey = (typeof ASK_PRESET_KEYS)[number];

export const ASK_CATEGORIES: AskCategory[] = ['我的工作', '进度与风险', '承诺与交付', '依赖与协作', '汇报与沟通', '资源与负荷'];

export const ASK_PRESETS: AskPreset[] = [
  { key: 'my_progress', category: '我的工作', question: '我负责的项目最近两周有什么进展？' },
  { key: 'my_priorities', category: '我的工作', question: '我明天应该优先做什么？' },
  { key: 'blockers', category: '进度与风险', question: '哪些项目卡住了，卡在哪、卡了多久、需要谁推动？' },
  { key: 'delay_risk', category: '进度与风险', question: '哪些项目有延期风险？' },
  { key: 'stalled', category: '进度与风险', question: '哪些项目很久没有进展了？' },
  { key: 'risk_register', category: '进度与风险', question: '帮我整理一份风险清单，按影响和紧急程度排序' },
  { key: 'commitments', category: '承诺与交付', question: '最近有哪些事说了要做、还没做？' },
  { key: 'due_soon', category: '承诺与交付', question: '接下来两周有哪些项目要到期，进度跟得上吗？' },
  { key: 'milestones', category: '承诺与交付', question: '最近两周完成了哪些关键节点？' },
  { key: 'waiting', category: '依赖与协作', question: '哪些事在等别人（客户、供应商、认证机构、其他部门）？' },
  { key: 'cross_team', category: '依赖与协作', question: '哪些事需要跨部门协调，该找谁？' },
  { key: 'weekly_summary', category: '汇报与沟通', question: '帮我写一份本周项目进展摘要' },
  { key: 'standup', category: '汇报与沟通', question: '按站会格式整理：昨天做了什么、今天计划、有什么阻塞' },
  { key: 'project_brief', category: '汇报与沟通', question: '某个项目的现状、风险和下一步', needsProject: true },
  { key: 'workload', category: '资源与负荷', question: '团队里谁手上的项目最多，负荷是否均衡？', managerOnly: true },
  { key: 'reporting_gaps', category: '资源与负荷', question: '哪些人或项目最近日报写得少、信息不够？', managerOnly: true },
];
